import type {State} from "./content-cache-types.ts";

const _mergeCourseIdBySlug = (
    spread: State["courseIdBySlug"],
    onto: State["courseIdBySlug"],
): State["courseIdBySlug"] => {
    return {...onto, ...spread};
};

const _mergeCoursesById = (
    spread: State["courseById"],
    onto: State["courseById"],
): State["courseById"] => {
    return {...onto, ...spread};
};

const _mergeLearnableContentById = (
    spread: State["learnableContentById"],
    onto: State["learnableContentById"],
): State["learnableContentById"] => {
    return {...onto, ...spread};
};

const _mergeLearnableContentIdBySlug = (
    spread: State["learnableContentIdByKindAndSlug"],
    onto: State["learnableContentIdByKindAndSlug"],
): State["learnableContentIdByKindAndSlug"] => {
    return {...onto, ...spread};
};

const _mergeUnitIdBySlug = (
    spread: State["unitIdBySlug"],
    onto: State["unitIdBySlug"],
): State["unitIdBySlug"] => {
    return {...onto, ...spread};
};

const _mergeUnitsById = (
    spread: State["unitById"],
    onto: State["unitById"],
): State["unitById"] => {
    return {...onto, ...spread};
};

const _mergeUnlistedUnitsByCourseId = (
    spread: State["unlistedUnitIdsByCourseId"],
    onto: State["unlistedUnitIdsByCourseId"],
): State["unlistedUnitIdsByCourseId"] => {
    return {...onto, ...spread};
};

/**
 * mergeState combines two state objects with the `spread` object taking
 * precedence over the `onto` object.
 *
 */
export const mergeState = (spread: State, onto: State): State => {
    return {
        courseIdBySlug: _mergeCourseIdBySlug(
            spread.courseIdBySlug,
            onto.courseIdBySlug,
        ),
        courseById: _mergeCoursesById(spread.courseById, onto.courseById),
        learnableContentById: _mergeLearnableContentById(
            spread.learnableContentById,
            onto.learnableContentById,
        ),
        learnableContentIdByKindAndSlug: _mergeLearnableContentIdBySlug(
            spread.learnableContentIdByKindAndSlug,
            onto.learnableContentIdByKindAndSlug,
        ),
        unitIdBySlug: _mergeUnitIdBySlug(
            spread.unitIdBySlug,
            onto.unitIdBySlug,
        ),
        unitById: _mergeUnitsById(spread.unitById, onto.unitById),
        publishedContentVersion:
            spread.publishedContentVersion || onto.publishedContentVersion,
        unlistedUnitIdsByCourseId: _mergeUnlistedUnitsByCourseId(
            spread.unlistedUnitIdsByCourseId,
            onto.unlistedUnitIdsByCourseId,
        ),
        lessonById: {
            ...onto.lessonById,
            ...spread.lessonById,
        },
        lessonIdBySlug: {
            ...onto.lessonIdBySlug,
            ...spread.lessonIdBySlug,
        },
    };
};
